<template name="detailLeftTop">
  <div>
    <div ref="detail" class="invite-detail" :class="{'scrolled': this.scrolled, 'show-popup': this.showPopup || this.showCheckPopup, 'show-modal': this.modalTip, 'remove-item': this.newDeviceLayout}">
      <div class="header" :class="{'posiFix': this.scrolled}">
        <div class="header-inner">
          <div class="row top" :class="{'posiFix': this.scrolled}">
            <h2 class=" col-9 title">{{this.inviteData.typeName}}{{this.inviteData.areaName}}
            </h2>
          </div>
          <div class="member row">
            <div class="total"><strong>{{this.inviteData.invitedCount}}</strong>邀请人数</div>
            <div class="audited"><strong>{{this.inviteData.auditedCount}}</strong>已审批</div>
            <div class="unaudited"><strong>{{this.inviteData.pendingReviewCount}}</strong>待审批</div>
          </div>
          <div class="header-content">
            <div class="name"><strong>开始时间: </strong> {{this.inviteData.startDay}}</div>
            <div class="name"><strong>结束时间: </strong> {{this.inviteData.endDay}}</div>
            <div class="apply-time" v-if="this.inviteData.isCarrierTicket"><strong>{{$t('ExpectedVisitPeriod')}}: </strong>{{this.inviteData.schedule}}</div>
            <div class="dock-number" v-if="this.inviteData.dockNumber"><strong>{{$t('DockNumber')}}:</strong> {{this.inviteData.dockNumber}}</div>
            <div class="business"><strong>访问类型: </strong> {{this.inviteData.typeName}}</div>
            <div class="business"><strong>访问区域: </strong> {{this.inviteData.areaName}}</div>
            <div class="bottler-order" v-if="this.inviteData.bottleOrderNumberList && this.inviteData.bottleOrderNumberList.length && this.inviteData.isCarrierTicket"><strong>{{$t('bottler')}}/{{$t('OrderNumber')}}: </strong>  
              <span v-for="(item, index) in this.inviteData.bottleOrderNumberList" :key="index">{{item.bottleName}}<span v-if="item.orderNumber">/</span>{{item.orderNumber}} </span>
            </div>
            <div class="apply-status" v-if="this.inviteData.isCarrierTicket"><strong>{{$t('ApplyStatus')}}: </strong>{{this.inviteData.checkStatusText}}</div>
            <div class="training" v-show="this.lessonList !='' "><strong>培训课程:</strong> {{this.lessonList}}</div>
            <div class="creater"><strong>创建人:</strong>  {{this.inviteData.creatorName}}</div>
            <div class="approver-copier row"  v-show="gmListShow"  v-for='(item, i) in this.inviteData.gmList'>
              <div v-if="item.gmName">
                <strong>GM审批人:</strong>  {{item.gmName}}
              </div>
              <div class="approver">
                <span v-if="item.gmCheckStatus == 0"><i class="iconfont icon-clock"></i>待通知</span>
                <span v-if="item.gmCheckStatus == 1"><i class="iconfont icon-clock"></i>待审批</span>
                <span v-if="item.gmCheckStatus == 2"><i class="iconfont icon-clock"></i>已拒绝</span>
                <span v-if="item.gmCheckStatus == 3"><i class="iconfont icon-clock"></i>已审批</span>
              </div>
            </div>

            <div class="approver-copier row" v-for='(item, i) in this.approverList'>
              <div class="">
                <strong>审批人:</strong> {{item.materialApproverName}}
              </div>
              <div class="approver">
                <span v-if="item.materialApproverStatus == 0"><i class="iconfont icon-clock"></i>待通知</span>
                <span v-if="item.materialApproverStatus == 1"><i class="iconfont icon-clock"></i>待审批</span>
                 <span v-if="item.materialApproverStatus == 2"><i class="iconfont icon-clock"></i>已拒绝</span>
                <span v-if="item.materialApproverStatus == 3"><i class="iconfont icon-clock"></i>已审批</span>
              </div>
            </div>
            <div v-if="this.ccNameList !='' ">
              <div class="copier"><strong>抄送人:</strong>  {{this.ccNameList}}</div>
            </div>
            
            <transition name="slide-fade" v-show="this.visitReason">
              <div class="other">
                <div class="area" v-if="this.inviteData.visitAreaDetail"><strong>访问细分区域:</strong>  {{this.inviteData.visitAreaDetail}}</div>
                <div class="purpose" v-if="this.inviteData.visitReason"><strong>访问目的说明:</strong>  {{this.inviteData.visitReason}}</div>
              </div>
            </transition>
          </div>
        </div>
        <div class="header-bg"></div>
      </div>
      <transition>
        <div v-show="this.showComfirmDelete">
          <tipModal ref="detailDialogShow"  :currentStatus="this.deleteInvitationId" :invitationId = "this.routId" @closeModal="closeModal"   :goodsListId="this.goodsListId" :approverId="this.approverId"></tipModal>
        </div>
      </transition>
      <transition name="fade">
        <div class="tip" v-show="this.modalTip">
          <div class="tip-inner">
            <div class="tip-text">{{modalTipText}}</div>
            <div class="comfirmBtn" @click="modalTip = !modalTip">确定</div>
          </div>
        </div>
      </transition>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>
<script>
import tipModal from '@/components/tipModal.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { securityGetOverviewInfo } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import photoSwipe from '@/components/photoSwipe.vue';
import { setupLang } from '@/locales';
import { setLanguage } from '@/utils/api';
import Bus from '@/utils/Bus';

export default {
  name: 'InviteDetail',
  props: {
    routId: String,
    newDeviceLayout: Boolean,
  },
  components: {
    tipModal,
    Loading,
    photoSwipe,
  },
  watch: {
    routId(newValue, oldValue) {
      // console.log(newValue,oldValue);
     this.invitationId = newValue;
     this.comment(this.invitationId);
    }
  },
  created() {
    this.comment(this.routId);
  },
  data() {
    return {
      showLanguage: false,
      locale: window.localStorage.getItem('localeLanguage'),
      phone: '',
      showOther: false,
      scrolled: false,
      userType: 'warehouse',
      isTicketOwner: false,
      showPopup: false,
      modalTip: false,
      modalTipText: '',
      textareaAll: '',
      approverList: [],
      ccNameList: '',
      gmListShow: false,
      gmList: [],
      visitReason: false,
      isOwner: false,
      isCheckOwner: false,
      lessonList: '',
      showCheckPopup: false,
      goodsListId: '',
      textareaCheckDetail: '',
      checkList: [],
      visitorData: [],
      visitorListArray: [],
      progress: [],
      RejectType: [],
      DeleteText: '',
      showVisitorHouse: true,
      showComfirmDelete: false,
      deleteInvitationId: '',
      inviteGoodsList: [],
      goodsImages: [],
      currentGoods: {},
      approverId: '',
      isGoodsListChecker: false,
      lookImgs: false,
      // modify invite
      isLoading: false,
      isModifyInviteShow: false,
      inviteInfo: null,
      photoSwipeModal: false,
      showLoginOut: false,
      loginOut: '',
      showAddInvisitor: false,

      invitationId: '',
      inviteData: {},
      trackingType: -1,
      invitationStatus: -1,
      isSecurity: false,
    };
  },
  methods: {
    comment(routeID) {
      // top detail
      securityGetOverviewInfo(routeID).then((res) => {
        if (res.data.content.status == 1) {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.model) {
              this.inviteData = res.data.content.model;
            }
            
            this.$emit('invitationDataLoaded', this.inviteData);
            if (this.inviteData.approverList) {
              this.approverList = this.inviteData.approverList;
            }
            if (this.inviteData.ccName) {
              const ccNameList = this.inviteData.ccName;
              this.ccNameList = ccNameList.join('/');
            }
            if (this.inviteData.gmList) {
              this.gmList = this.inviteData.gmList;
              this.gmListShow = true;
            } else {
              this.gmListShow = false;
            }
            if (this.inviteData.visitAreaDetail === '' && this.inviteData.visitReason === '') {
              this.visitReason = false;
            } else {
              this.visitReason = true;
            }
            this.isOwner = this.inviteData.isOwner;
            this.isCheckOwner = this.inviteData.isCheck;
            this.isSecurity = this.inviteData.isSecurity;
            this.$emit('isOwner', this.isOwner);
            this.$emit('isCheckOwner', this.isCheckOwner);
            this.$emit('isSecurity', this.isSecurity);
            // console.log(`${this.isSecurity}`);
            // console.log(`创建人${this.isOwner}`);
            // console.log(`审批人${this.isCheckOwner}`);
            if (this.inviteData.lessonName) {
              const lessonName = this.inviteData.lessonName;
              this.lessonList = lessonName.join('/');
            }
            this.trackingType = this.inviteData.trackingType;
            this.invitationStatus = this.inviteData.invitationStatus;
            this.$emit('trackingType', this.trackingType);
            this.$emit('invitationStatus', this.invitationStatus);
            this.$emit('ifEnable', this.inviteData.ifEnable)
            // console.log(`是否过期${this.inviteData.ifEnable}`)
            // console.log('isWareHouse=='+this.trackingType)
            Bus.$emit('to-trackingType', this.trackingType);
          }
        } else {
          this.$router.push({ path: '/security/index' });
        }
      });
    },
    loadData(data, ifEnable) {
      // console.log(data);
      if (data) {
        this.inviteData = data;
      }
      if (this.inviteData.lessonName) {
        const lessonName = this.inviteData.lessonName;
        this.lessonList = lessonName.join('/');
      }
      this.showAddInvisitor = ifEnable;
    },
    closeModal(status) {
      this.showComfirmDelete = status;
    },
    remindApproval(e) {
      const ApproverId = e.target.dataset.value;
      const statusId = e.target.dataset.status;
      if (statusId == 1) {
        this.deleteInvitationId = 'remindApproval';
        this.approverId = ApproverId;
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'remindApproval',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      } else {
        sendRemind(ApproverId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      }
    },
    deleteCheckDetail(e) {
      const GoodsListId = e.target.dataset.value;
      this.invitationId = this.routId;
      this.goodsListId = GoodsListId;
      if (this.invitationId && this.goodsListId) {
        this.deleteInvitationId = 'deleteCheckGoods';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteCheckGoods',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    closeCheckModal() {
      this.showCheckPopup = false;
      this.textareaCheckDetail = '';
    },
    showLookImgs(status) {
      this.lookImgs = status;
    },
    modifyInvite() {
      // console.log('yeep, you just click modify btn');
      this.isModifyInviteShow = true;
      getInvitationInfoForEdit(this.routId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          this.inviteInfo = res.data.content.model;
        }
      });
    },
    // TODO: this event's name is quite strange
    handleGetMessage() {
      this.isModifyInviteShow = false;
    },
    closePhoto() {
      this.photoSwipeModal = false;
    },
    forwardingOperation() {
      this.$emit('forWaringmodalShow', true);
    }
  }
};

</script>
<style lang="scss" scoped>
@import "../../scss/variables.scss";

.btn {

  &:focus,
  &:hover {
    box-shadow: none;
  }
}

.btn-default {
  border: 1px solid #929292;
  color: #9b9b9b;
}

.btn-red {
  color: #e42029;
  border: 1px solid #e42029;
}

.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);

  &:hover {
    color: #fff;
  }
}

.scrolled {

  .header:before,
  .header-bg {
    display: none;
  }

  .header {
    .title {
      margin-bottom: 0;
    }
  }
}

.operationDele {
  .header {
    padding-bottom: 10px;
  }
}

.show-popup,
.show-modal,
.show-status {
  height: 100vh;
  overflow: hidden;
  color: #4a4a4a;

  .reason,
  .tip {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);

    .tip-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 270px;
      border-radius: 12px;
      background-color: #fcfcfc;
      text-align: center;

      .tip-text {
        padding: 20px 0 15px;
        font-size: 17px;
        color: #4a4a4a;
      }

      .comfirmBtn {
        padding: 12px;
        font-size: 17px;
        color: #e42029;
      }
    }

    .icon-close {
      position: absolute;
      top: 10px;
      right: 5%;
      z-index: 10;
      font-size: 22px;
    }
  }

  .reson-inner {
    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    p {
      font-size: 13px;
      margin-bottom: 5px;
    }

    .reson-option {
      margin-bottom: 20px;
    }

    .refuse-reson {
      text-align: right;

      select {
        color: #929292;
        appearance: none;
        border: none;
        outline: none;
        padding-right: 9px;
        background: url('../../assets/images/arrow-copy.png') no-repeat right center;
        background-size: 7px;
      }
    }

    textarea {
      width: 100%;
      height: 175px;
      border: none;
      background: #f0f0f0;
      padding: 8px;
      font-size: 13px;
    }

    .form-group {
      margin-bottom: 25px;
    }

    .form-action {
      margin-bottom: 20px;
    }

    .btn {
      width: 100%;
    }

    .btn:hover {
      color: inherit;
    }
  }
}

.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.visit-show {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 15;
  background: rgba(0, 0, 0, 0.4);

  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

.invite-detail {
  width: 290px;
  // max-height: 345px;
  border-radius: 4px;
  &.remove-item {
    width: 100%;
  }
  .forwardingOperation {
    float: right;
    margin-right: 30px;
    cursor: pointer;

    span {
      padding: 5px 20px;
      border: 1px solid #fff;
      border-radius: 17px;
      cursor: pointer;
    }
  }
  .header {
    padding-bottom: 10px;
     z-index: 0;
  }
  @include respond-to('sm-max') {
    width: 100%;
    background: #fff;
    overflow: hidden;
    float: none;

    .header {
      height: auto;
      background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
      position: relative;
      z-index: 0;
      color: #fff;
      font-size: 13px;
      border-radius: 0;
      padding-bottom: 10px;

      &.posiFix {
        z-index: 11;
      }

      &.operationDele {
        padding-bottom: 50px;
      }

      .header-inner {
        padding: 15px !important;
        position: relative;
        z-index: 9;

        .top {
          &>div:last-child {
            text-align: right;
            padding-right: 30px;
          }
        }

        .posiFix {
          position: fixed;
          top: 0;
          z-index: 11;
          width: 100%;
          padding: 10px 0;
          background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
          align-items: center;
        }
      }

      .title {
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      &:before {
        content: '';
        width: 110px;
        height: 110px;
        border-radius: 0 0 0 110px;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        border-left: 30px solid #fff;
        border-bottom: 30px solid #fff;
        opacity: 0.12;
      }

      .status-send-msg {
        .status {
          font-size: 13px;

          i {
            margin-right: 5px;
            font-size: 13px;
          }
        }

        .send-msg {
          font-size: 12px;
          text-align: right;

          span {
            border-bottom: 1px solid #fff;
          }
        }
      }

      .approver-copier {
        margin: 0;

        .approver {
          padding: 0;

          span {
            border: 1px solid #fff;
            margin-left: 10px;
            padding: 1px;
            font-size: 11px;

            i {
              font-size: 12px;
            }
          }
        }

        .remind {
          text-align: right;

          span {
            cursor: pointer;
            padding-bottom: 2px;
            border-bottom: 1px solid #fff;
            font-size: 11px;
          }
        }
      }

      .member {
        margin: 0;
        &>div {
          padding: 0 15px;
        }

        strong {
          font-size: 15px;
          margin-right: 5px;
        }
      }

      .forwardingOperation {
        float: right;
        margin-right: 30px;
        cursor: pointer;

        span {
          padding: 5px 20px;
          border: 1px solid #fff;
          border-radius: 17px;
          cursor: pointer;
        }
      }

      .operation {
        float: right;
        margin-top: 10px;

        &.operationBtn {
          margin-top: -8px;
        }

        div {
          cursor: pointer;
          border-radius: 17px;
          border: solid 1px #ffffff;
          padding: 3px 20px;
          margin-right: 10px;
        }

        &>div:last-child {
          margin-right: 25px;
        }
      }
    }

    .go-back {
      color: #fff;

      .iconfont {
        font-size: 22px;
      }
    }

    .handle-group {
      margin-top: 10px;
    }

    .btn-toggle {
      float: left;

      i {
        font-size: 12px;
        display: inline-block;
        transform: scale(0.5, 0.5);
        margin-right: -2px;
      }

      span {
        display: block;
        padding: 0 5px 0 0;
        font-size: 11px;
        background: rgba(255, 255, 255, .35);
        line-height: 20px;
        border-radius: 10px;
      }
    }

    .btn-edit {
      font-size: 13px;
      line-height: 28px;
      padding: 0 20px;
      border-radius: 15px;
      border: 1px solid #fff;
      float: right;

      i {
        margin-right: 5px;
        display: inline-block;
      }
    }

    .header-bg {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      z-index: 1;

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.06;
      }

      &:before {
        width: 80px;
        height: 80px;
        border-radius: 0 80px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }

      &:after {
        width: 150px;
        height: 150px;
        border-radius: 0 150px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }
    }

    .content {
      background-color: #fff;
      border-radius: 10px 10px 0 0;
      //padding-top: 20px;
      width: 100%;
      margin-top: -10px;
      position: relative;
      z-index: 10;

      &.lookImgs {
        z-index: 12;
      }
    }
  }

  @include respond-to('ml') {
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    float: none;
    width: 290px;

    .header {
      height: auto;
      background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
      position: relative;
      z-index: 0;
      color: #fff;
      font-size: 13px;
      border-radius: 0;
      padding-bottom: 10px;

      &.posiFix {
        z-index: 11;
      }

      &.operationDele {
        padding-bottom: 50px;
      }

      .header-inner {
        padding: 15px !important;
        position: relative;
        z-index: 9;

        .top {
          &>div:last-child {
            text-align: right;
            padding-right: 30px;
          }
        }
        
        .header-content {
          div {
            padding: 2px 0;
          }
        }
        .posiFix {
          position: fixed;
          top: 0;
          z-index: 11;
          width: 100%;
          padding: 10px 0;
          background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
          align-items: center;
        }
      }

      .title {
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      &:before {
        content: '';
        width: 110px;
        height: 110px;
        border-radius: 0 0 0 110px;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        border-left: 30px solid #fff;
        border-bottom: 30px solid #fff;
        opacity: 0.12;
      }

      .status-send-msg {
        .status {
          font-size: 13px;

          i {
            margin-right: 5px;
            font-size: 13px;
          }
        }

        .send-msg {
          font-size: 12px;
          text-align: right;

          span {
            border-bottom: 1px solid #fff;
          }
        }
      }

      .approver-copier {
        margin: 0;

        .approver {
          padding: 0;

          span {
            border: 1px solid #fff;
            margin-left: 10px;
            padding: 1px;
            font-size: 11px;

            i {
              font-size: 12px;
            }
          }
        }

        .remind {
          text-align: right;

          span {
            cursor: pointer;
            padding-bottom: 2px;
            border-bottom: 1px solid #fff;
            font-size: 11px;
          }
        }
      }

      .member {
        &>div {
          padding: 0 15px;
        }

        strong {
          font-size: 15px;
          margin-right: 5px;
        }
      }

      .forwardingOperation {
        float: right;
        margin-right: 30px;
        cursor: pointer;
        span {
          padding: 5px 20px;
          border: 1px solid #fff;
          border-radius: 17px;
        }
      }

      .operation {
        float: right;
        margin-top: 10px;

        &.operationBtn {
          margin-top: -8px;
        }

        div {
          cursor: pointer;
          border-radius: 17px;
          border: solid 1px #ffffff;
          padding: 3px 20px;
          margin-right: 10px;
        }

        &>div:last-child {
          margin-right: 25px;
        }
      }
    }

    .go-back {
      color: #fff;

      .iconfont {
        font-size: 22px;
      }
    }

    .handle-group {
      margin-top: 10px;
    }

    .btn-toggle {
      float: left;

      i {
        font-size: 12px;
        display: inline-block;
        transform: scale(0.5, 0.5);
        margin-right: -2px;
      }

      span {
        display: block;
        padding: 0 5px 0 0;
        font-size: 11px;
        background: rgba(255, 255, 255, .35);
        line-height: 20px;
        border-radius: 10px;
      }
    }

    .btn-edit {
      font-size: 13px;
      line-height: 28px;
      padding: 0 20px;
      border-radius: 15px;
      border: 1px solid #fff;
      float: right;

      i {
        margin-right: 5px;
        display: inline-block;
      }
    }

    .header-bg {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      z-index: 1;

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.06;
      }

      &:before {
        width: 80px;
        height: 80px;
        border-radius: 0 80px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }

      &:after {
        width: 150px;
        height: 150px;
        border-radius: 0 150px 0 0;
        border-right: 30px solid #fff;
        border-top: 30px solid #fff;
      }
    }

    .content {
      background-color: #fff;
      border-radius: 10px 10px 0 0;
      //padding-top: 20px;
      width: 100%;
      margin-top: -10px;
      position: relative;
      z-index: 10;

      &.lookImgs {
        z-index: 12;
      }
    }
  }

  .header-inner {
    padding: 15px !important;
  }
}

</style>
